/*
  Project: Glamydays
  Author: schrittweiter
 */

import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons';

// loads the Icon plugin
UIkit.use(Icons);

import scrollTop from './modules/scrollTop';
import viewport from './modules/viewport';
import share from './modules/share';
import slidein from './modules/slidein';
import quickview from './modules/quickview';
import facetParse from './modules/facetParse';
import facetObserver from './modules/facetObserver';
import onPageNav from './modules/onPageNav';
import accordionTabs from './modules/accordionTabs';
import quickNav from './modules/quickNav';
import slider from './modules/slider';
import categoryDropdown from './modules/categoryDropdown';
import producttab from './modules/producttab';
import flipcard from './modules/flipcard';
import bubbles from './modules/bubbles';
import './modules/gLightbox';
import'./modules/facetMarkup';
import './modules/tracking';
import './modules/login';

scrollTop();
onPageNav();
share();
slidein();
categoryDropdown();
quickview();

facetParse();
facetObserver();

accordionTabs();
quickNav();
viewport();

slider();
flipcard();
producttab();

bubbles();

let resizeTimer,
    lastWindowWidth;

jQuery(document).ready(function(e) {
  viewport();
});

jQuery(window).on('resize', function(e) {
  let $window = jQuery(this),
      windowWidth = $window.width();

  clearTimeout(resizeTimer);

  if(lastWindowWidth != windowWidth ) {
    resizeTimer = setTimeout(function() {
      accordionTabs();
      quickNav();
      lastWindowWidth = windowWidth;
    }, 250);
  }
});
